import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import TableBody from '@mui/material/TableBody';

const StyledTableBody = styled(TableBody)`
  ${ComponentStyles}
`;

StyledTableBody.propTypes = {
  theme: PropTypes.object
};

export default StyledTableBody;
